import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { InsuranceAction } from '@typesApp/InsuranceActionListener'
import { insuranceListenersSelector } from '@redux/slices/insuranceMemberSlice'
import { invokeInsuranceActionListeners } from '@utils/invokeInsuranceListeners'

type InvokerFunction = (action: InsuranceAction) => Promise<void>

export const useInvokeInsuranceActionListeners = (): InvokerFunction => {
  const listenerList = useSelector(insuranceListenersSelector)

  const invokeListeners = useCallback(
    (action: InsuranceAction): Promise<void> => {
      return new Promise(resolve => {
        try {
          invokeInsuranceActionListeners(listenerList, action)
        } finally {
          resolve()
        }
      })
    },
    [listenerList]
  )

  return invokeListeners
}
